import React from 'react';
import PropTypes from 'prop-types';

import { GlobalStyles } from '../../styles';
import { FallbackPageMeta } from '../';
import '../../assets/css/bootstrap.min.css';

const LayoutBasis = ({ children }) => (
  <>
    <FallbackPageMeta />
    <GlobalStyles />
    {children}
  </>
);

LayoutBasis.propTypes = {
  children: PropTypes.node,
};

export default LayoutBasis;
